export const fieldsWithInitValue2OriginRecord = fieldsWithInitValue => {
  const originRecord = {};
  fieldsWithInitValue.forEach(item => {
    if (!item.type) {
      originRecord[item.id] = item.initialValue;
    } else {
      if (Array.isArray(item.data)) {
        item.data.forEach(dataItem => {
          originRecord[dataItem.id] = dataItem.initialValue;
        });
      }
    }
  });
  return originRecord;
};

/**
 * @param {array} fieldsWithInitValue refer to the datastructure for the data prop in FormData/propTypes.js
 */
export const getOnlyChangesFormData = (fieldsWithInitValue, filledFormData) => {
  const originRecord = fieldsWithInitValue2OriginRecord(fieldsWithInitValue);
  const keys = Object.keys(filledFormData);

  const ret = {};
  keys.forEach(key => {
    if (originRecord[key] !== filledFormData[key]) {
      ret[key] = filledFormData[key];
    }
  });

  return ret;
};
